import AjaxPress from "./ajaxpress";
window.AjaxPress = AjaxPress;